module.exports = __webpack_public_path__ + "static/headshot-rob-fry-3x.a264dd93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-rob-fry-3x.jpg
// module id = 139
// module chunks = 35783957827783 152909308826437